<template>
	<vue100vh style="position: fixed; width: -webkit-fill-available !important; overflow-x: hidden;">
		<div class="CSChatThai BGwhite">
			<v-toolbar style="background-color: white !important;">
				<!-- <v-btn icon @click="toPage('/web/homepage')">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn> -->
				<v-toolbar-title>{{ $t('HeaderMenubar.managefriend') }}</v-toolbar-title>
			</v-toolbar>
			<v-card-text v-if="progress"
				style="align-items: center; display: flex; margin-top: 70px; justify-content: center;">
				<v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
			</v-card-text>
			<v-card-text v-else
				style="margin-top:0vh; margin-bottom:0vh; justify-content: center !important; overflow-y: scroll; height: calc(100vh - 64px); color: rgb(74, 74, 74) !important;">
				<v-flex xs12 sm12 md12 v-if="listblock.length !== 0">
					<v-list two-line>
						<v-list-item v-for="(item, index) in listblock" :key="item.tokenuser" avatar>
							<v-list-item-avatar>
								<img :src="item.profilepicture" v-if="item.profilepicture !== ''" class="alligator-turtle">
								<img :src="`${publicPath}/assets/img/default_profile/bot-white.png`" v-else-if="item.type === 'bot'"
									class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #efefef;">
								<img :src="`${publicPath}/assets/img/default_profile/business-white.png`"
									v-else-if="item.type === 'business'" class="alligator-turtle"
									style="border-style: solid; border-width: thin; border-color: #efefef;">
								<img :src="`${publicPath}/assets/img/default_profile/man-white.png`" v-else class="alligator-turtle"
									style="border-style: solid; border-width: thin; border-color: #efefef;">
							</v-list-item-avatar>

							<v-list-item-content>
								<v-list-item-title v-html="item.name" class="text2"></v-list-item-title>
							</v-list-item-content>

							<v-list-item-action>
								<v-row>
									<v-tooltip top>
										<template v-slot:activator="{ on, attrs }">
											<v-btn icon v-bind="attrs" v-on="on" @click="remove_friend(item, index)">
												<v-icon dark color="grey darken-1" style="font-size: 20px;">mdi-account-minus</v-icon>
											</v-btn>
										</template>
										<span>{{ $t('AnswerQuestion.removeFriend') }}</span>
									</v-tooltip>
									<v-tooltip top>
										<template v-slot:activator="{ on, attrs }">
											<v-btn icon v-bind="attrs" v-on="on" @click="unblock(item, index)">
												<v-icon dark color="grey darken-1" style="font-size: 20px;">mdi-lock-open-outline</v-icon>
											</v-btn>
										</template>
										<span>{{ $t('AnswerQuestion.unblock') }}</span>
									</v-tooltip>
								</v-row>
							</v-list-item-action>
						</v-list-item>
					</v-list>
				</v-flex>
				<v-flex xs12 md12 sm12 v-else>
					<h4 style="display: flex; justify-content: center;">{{ $t('Settings.manageFriend.nodata') }}</h4>
				</v-flex>
			</v-card-text>
		</div>
	</vue100vh>
</template>
<script>
import { sync } from 'vuex-pathify'
//   import { Decode } from '@/services'
import vue100vh from 'vue-100vh'
// var _ = require('lodash')

export default {
	data: () => ({
		publicPath: process.env.VUE_APP_BASE_PATH,
		listblock: [],
		token: '',
		progress: false,
		data_user: {},
	}),
	components: {
		vue100vh
	},
	methods: {
		toPage(data) {
			this.$router.push(data)
		},
		getlistblock() {
			// console.log('getlistblock')
			this.progress = true
			this.axios.post(process.env.VUE_APP_API_GO + '/v1/get-list-block', { tokenuser: this.token }).then((response) => {
				if (response.data.status === 'success') {
					this.progress = false
					this.listblock = response.data['list_block_friend']
					// console.log(this.listblock)
				}
			}).catch(error => {
				console.log(error)
				this.progress = false
			})
		},
		unblock(item, index) {
			// console.log(item)
			this.$swal({
				title: this.$t('Alert.Sure'),
				text: this.$t('Alert.Unblocking', { name: item.name }),
				type: 'warning',
				imageHeight: 70,
				showCancelButton: true,
				confirmButtonColor: '#2562af',
				cancelButtonColor: '#9f9f9f',
				confirmButtonText: this.$t('AnswerQuestion.ok'),
				cancelButtonText: this.$t('AnswerQuestion.cancel'),
				confirmButtonClass: 'btn btn-danger',
				cancelButtonClass: 'btn btn-success',
				buttonsStyling: true,
				showCloseButton: true,
				reverseButtons: true
			}).then((result) => {
				if (result.value) {
					this.axios.post(process.env.VUE_APP_API_MANAGE + '/unblockfriend', { tokenfriend: item.tokenuser, tokenuser: this.token, tokenroom: item.tokenroom }).then((response) => {
						if (response.data['status'] === 'success') {
							// this.getlistblock()
							this.listblock.splice(index, 1)
							item.event = 'unblock_friend'
							// this.unblock_friend = item
							this.block_friend = item
							this.$swal('', this.$t('Alert.Success.unblock'), 'success')
						}
					})
				}
			})
		},
		remove_friend(item, index) {
			// console.log('remove_friend')
			this.$swal({
				title: this.$t('Alert.Sure'),
				text: this.$t('Alert.RemoveFriend', { name: item.name }),
				type: 'warning',
				imageHeight: 70,
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: this.$t('AnswerQuestion.ok'),
				cancelButtonText: this.$t('AnswerQuestion.cancel'),
				confirmButtonClass: 'btn btn-danger',
				cancelButtonClass: 'btn btn-success',
				buttonsStyling: true,
				showCloseButton: true,
				reverseButtons: true
			}).then((result) => {
				if (result.value) {
					this.axios.post(process.env.VUE_APP_API_MANAGE + '/removefriend', { tokenfriend: item.tokenuser, tokenuser: this.token, tokenroom: item.tokenroom }).then((response) => {
						if (response.data['status'] === 'success') {
							this.$swal('', this.$t('Alert.Success.removefriend'), 'success')
							this.listblock.splice(index, 1)
							// this.getlistblock()
							// this.$router.push('/chat/homepage')
						}
					})
				}
			})
		},
		detailFriend(user) {
			var title = 'ข้อมูลส่วนตัว'
			var picture = user.profilepicture
			if (user.profilepicture === '') {
				if (user.type === 'business') {
					picture = `${this.publicPath}/assets/img/default_profile/business-white.png`
				} else if (user.type === 'bot') {
					picture = `${this.publicPath}/assets/img/default_profile/bot-white.png`
				} else {
					picture = `${this.publicPath}/assets/img/default_profile/man-white.png`
				}
			} else {
				picture = user.profilepicture
			}
			var name = user.name
			this.$swal({
				title: '<div class="CSChatThai">' + title + '</div>',
				html: '<br><img src="' + picture + '" style=" width: 140px; height: 140px; background: #a84909; border-radius: 50%; object-fit: cover; object-position: 50% 0;"><br><br><br>' + '<div class="CSChatThai" style="text-align:left">ชื่อ: ' + name + '<br><br><br><button id="unblock" style="background-color: #536475;border: #bebec1 1px solid;border-radius: 50px; padding: 9px;color: white;right: 10px; float:right;   margin-left: 10px;"> ยกเลิกการบล็อค </button>' + '<button id="unfriend" style="background-color: #fb3e3e;border-radius: 50px; padding: 9px;color: white; right:0; float:right;"> ลบเพื่อน </button>' + '</div>',
				buttonsStyling: true,
				showCloseButton: true,
				reverseButtons: true,
				showCancelButton: false,
				showConfirmButton: false,
				onBeforeOpen: () => {
					const content = this.$swal.getContent()
					const $ = content.querySelector.bind(content)
					const unblock = $('#unblock')
					unblock.addEventListener('click', () => {
						// console.log('increase')
						this.getlistblock()
					})
				}
			})
		}
	},
	computed: {
		...sync('*')
	},
	// watch: {
	// },
	created() {
		//   var decoded = JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
		//   this.token = decoded['tokenuser']
		var user_profile = ''
		if (JSON.parse(this.$cookie.get('user-profile') == null)) {
			user_profile = JSON.parse(localStorage.getItem('user-profile'))
		} else {
			user_profile = JSON.parse(this.$cookie.get('user-profile'))
		}
		this.data_user = user_profile['account']['profile']
		this.token = this.data_user.tokenuser;
		this.getlistblock()
		this.$i18n.locale = (this.$cookie.get('language')) ? this.$cookie.get('language') : 'th'
	}
}
</script>
<style type="text/css" scoped>
.text2 {
	white-space: nowrap;
	width: 140px;
	overflow: hidden;
	text-overflow: ellipsis;
}

.alligator-turtle {
	object-fit: cover;
	object-position: 50% 0;
}

>>>.v-toolbar {
	/* box-shadow: none; */
	box-shadow: 0 2px 0px -1px hsla(0, 0%, 100%, .12), 0 0px 5px 0 rgba(0, 0, 0, .14), 0 1px 10px 0 rgba(0, 0, 0, .12) !important;
}

>>>.v-toolbar__title:not(:first-child) {
	margin-left: 0px;
}

.Kanit {
	font-family: 'Kanit', sans-serif !important;
}

.edit {
	font-weight: 100;
}

.inputWrapper {
	height: 32px;
	width: 90px;
	overflow: hidden;
	position: relative;
	cursor: pointer;
}

.img {
	display: block;
	max-width: 230px;
	max-height: 95px;
	width: auto;
	height: auto;
}

.alligator-turtle {
	object-fit: cover;
	object-position: 50% 0;
}

.dialog .dialog--active .dialog--persistent {
	max-height: 107vh;
	overflow: hidden;
}

.card__text {
	padding-left: 16px;
	padding-right: 16px;
	padding-bottom: 16px;
	overflow: hidden;
}

.CSChatThai {
	font-family: 'CS ChatThaiUI' !important;
	word-wrap: break-word;
}

.textbusiness {
	margin-top: 1vh;
	font-family: 'CS ChatThaiUI' !important;
	word-wrap: break-word;
	/*width: 300px;*/
}

input[type=textprofile] {

	width: 100%;
	box-sizing: border-box;
	border: 2px solid #ccc;
	border-radius: 4px;
	font-size: 16px;
	background-color: white;
	/*background-image: url('../assets/image/group.png');*/
	background-position: 10px 10px;
	background-repeat: no-repeat;
	padding: 10px 10px 10px 10px;
	-webkit-transition: width 0.4s ease-in-out;
	transition: width 0.4s ease-in-out;
}

input[type=textprofile]:disabled {
	background: #cac9c9;
}

.EndpointUrl:hover .urlcopymessageapi {
	display: inline !important;
}

.urlcopymessageapi {
	display: none !important;
}

.EndpointUrl {
	display: block;
	/*color: #6D7D8D;*/
}

.header {
	display: block;
	font-size: 1.17em;
	-webkit-margin-before: 1em;
	-webkit-margin-after: 1em;
	-webkit-margin-start: 0px;
	-webkit-margin-end: 0px;
	margin: 40px 0 20px;
	padding-left: 20px;
	line-height: 1.3;
	font-weight: bold;
	font-size: 16px;
	position: relative;
	color: black !important;
}

.header::before {
	content: "";
	display: inline-block;
	position: absolute;
	top: 50%;
	-webkit-transform: translateY(-50%);
	transform: translateY(-50%);
	left: 0;
	width: 0;
	height: 32px;
	border-left: 4px solid #1a76d2;
}

.Setting {
	margin-bottom: 2vh;
}

.SettingBlock {
	padding: 30px 20px;
	border-top: 1px solid #DEE5EC;
}

.SettingBlock> :last-child {
	margin-bottom: 0;
}

.List_Register {
	margin-bottom: 32px;
	box-sizing: border-box;
}

.List_Register .List_item:last-child {
	border-bottom: none;
}

.List_Register .List_item {
	display: -webkit-flex;
	display: flex;
	padding: 0;
}

.List_Register .List_item:last-child .List_item_header {
	width: 200px;
}

.SettingTtl {
	margin-bottom: 8px;
	font-weight: bold;
	white-space: nowrap;
	color: black !important;
}

.md91SettingImg {
	padding-bottom: 12px;
	line-height: 1;
}

.SettingImgWrap {
	display: inline-block;
	position: relative;
	border-radius: 40px;
	overflow: hidden;
}

.SettingImgMask {
	position: relative;
	width: 160px;
	height: 160px;
	overflow: hidden;
	border-radius: 40px;
}

.SettingImgBtn {
	display: block;
	overflow: hidden;
	position: absolute;
	bottom: -20px;
	right: -20px;
	line-height: 1;
	width: 40px;
	height: 30px;
	bottom: 0;
	left: 0;
	line-height: 30px;
	width: 100%;
	text-align: center;
	cursor: pointer;
	color: #fff;
	background: rgba(0, 0, 0, .5);
}

.SettingImgBtn:hover {
	display: block;
	overflow: hidden;
	position: absolute;
	bottom: -20px;
	right: -20px;
	line-height: 1;
	width: 40px;
	height: 50%;
	bottom: 0;
	left: 0;
	line-height: 30px;
	width: 100%;
	text-align: center;
	cursor: pointer;
	color: #fff;
	background: rgba(0, 0, 0, .75);
}

.SettingImgInput {
	position: absolute;
	left: -9999px;
}

.EditAreaNote {
	margin: 8px 0 0;
	font-size: 13px;
	color: #BEC8D2;
	font-size: 12px;
}

.EditArea {
	display: -webkit-flex;
	display: flex;
	-webkit-justify-content: space-between;
	justify-content: space-between;
	-webkit-align-items: center;
	align-items: center;
}

.BreakWord {
	white-space: pre-wrap;
	word-break: break-all;
	word-break: break-word;
	word-wrap: break-word;
}

.EditAreaCont {
	width: 100%;
	padding-right: 1em;
	box-sizing: border-box;
}

.SettingQr {
	display: -webkit-flex;
	display: flex;
}

.SettingQrImg {
	margin: 0 50px;
	position: relative;
}

.SettingQrNote {
	margin-bottom: 0;
	font-size: 13px;
}

.buttonedit {
	color: ghostwhite;
	border-radius: 4px;
	background-color: #2562af !important;
	border: solid 1px #2562af !important;
	-webkit-box-sizing: border-box !important;
	box-sizing: border-box !important;
	margin-right: 0 !important;
	text-align: center;
	font-weight: 400 !important;
	text-transform: none;
}

.buttoncancel {
	color: black;
	border-radius: 4px;
	background-color: #c1c1c196 !important;
	border: solid 1px #c1c1c1 !important;
	-webkit-box-sizing: border-box !important;
	box-sizing: border-box !important;
	margin-right: 0 !important;
	text-align: center;
	font-weight: 400 !important;
	text-transform: none;
}

.EditAreaContFlex {
	display: -webkit-flex;
	display: flex;
	-webkit-justify-content: space-between;
	justify-content: space-between;
	-webkit-align-items: center;
	align-items: center;
}

.InputEdit {
	width: 100%;
	padding: 10px 15px;
	box-sizing: border-box;
	background-color: #fff;
	border: 1px solid #d2d8dd;
	border-radius: 4px;
}

.CSChatThai {
	font-family: 'CS ChatThaiUI' !important;
	word-wrap: break-word;
}

.BGwhite {
	background-color: white !important;
}

/*.avatarpicBis:hover .overlay {
    opacity: 1;
  
  }*/
</style>